import React, { useEffect } from "react";
import { X } from "lucide-react";

export const inp = "w-full bg-white border border-[#E4DBCD] rounded-xl px-3.5 py-3 text-[15px] text-[#1C1A17] placeholder:text-[#B3AA9C] outline-none focus:border-[#9A7445] transition-colors";
export const btnMain = "inline-flex items-center justify-center gap-2 rounded-full bg-[#1C1A17] text-[#FAF7F2] text-sm px-5 py-3 hover:bg-[#3A342C] transition-colors disabled:opacity-40";
export const btnSoft = "inline-flex items-center justify-center gap-2 rounded-full border border-[#E4DBCD] bg-white text-[#1C1A17] text-sm px-4 py-2.5 hover:border-[#9A7445] transition-colors disabled:opacity-40";
export const btnIcon = "inline-flex items-center justify-center w-9 h-9 rounded-full text-[#8A8173] hover:bg-[#F1EBE1] hover:text-[#1C1A17] transition-colors";

export const Field = ({ label, children, className = "" }) => (
  <label className={`block ${className}`}>
    <span className="block text-[13px] text-[#6B645A] mb-1.5">{label}</span>
    {children}
  </label>
);

export const Card = ({ children, className = "", testid }) => (
  <div data-testid={testid} className={`bg-white border border-[#EEE5D8] rounded-2xl p-5 ${className}`}>{children}</div>
);

export const Big = ({ label, value, tone = "#1C1A17", testid, sub }) => (
  <Card testid={testid}>
    <p className="text-[13px] text-[#8A8173]">{label}</p>
    <p className="text-[28px] md:text-[34px] leading-tight font-semibold mt-1 break-words" style={{ color: tone }} dir="ltr">{value}</p>
    {sub && <p className="text-xs text-[#A59E93] mt-1">{sub}</p>}
  </Card>
);

export const Row = ({ label, value, strong, testid }) => (
  <div className="flex items-center justify-between gap-4 py-2.5 border-b border-[#F1EBE1] last:border-0" data-testid={testid}>
    <span className="text-sm text-[#6B645A]">{label}</span>
    <span className={`text-[15px] ${strong ? "font-semibold text-[#1C1A17]" : "text-[#3A342C]"}`} dir="ltr">{value}</span>
  </div>
);

export const Empty = ({ children }) => <div className="rounded-2xl border border-dashed border-[#E4DBCD] px-5 py-12 text-center text-[#8A8173] text-sm">{children}</div>;

const useEscape = (onClose) => useEffect(() => {
  const h = (e) => e.key === "Escape" && onClose();
  window.addEventListener("keydown", h);
  return () => window.removeEventListener("keydown", h);
}, [onClose]);

export const Sheet = ({ title, onClose, children, testid }) => {
  useEscape(onClose);
  return (
    <div className="fixed inset-0 z-[80] bg-black/40 flex items-end md:items-center justify-center md:p-6" onClick={onClose}>
      <div data-testid={testid} onClick={(e) => e.stopPropagation()} className="bg-[#FAF7F2] text-[#1C1A17] w-full md:max-w-2xl max-h-[94vh] overflow-y-auto rounded-t-3xl md:rounded-3xl p-5 md:p-8">
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-xl font-semibold">{title}</h3>
          <button onClick={onClose} data-testid={`${testid}-close`} className={btnIcon}><X size={20} /></button>
        </div>
        {children}
      </div>
    </div>
  );
};
